import { createFileRoute } from "@tanstack/react-router";

import { LivesheetDataView } from "~/components/feature/livesheet/components/LivesheetDataView";

export const Route = createFileRoute("/_app/livesheet/resultados")({
  component: RouteComponent,
});

function RouteComponent() {
  return <LivesheetDataView tab="resultados" />;
}
